
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    class BaseSettingModel {
        endTime: Date;
    }
    @Component
    export default class EditLogisticsModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;

        Model: BaseSettingModel = new BaseSettingModel();

        created() {

        }
        async save() {
            var id = this.$store.state.overseasbasecostsetting.id;
            await this.$store.dispatch({
                type: 'overseasbasecostsetting/editEndTime',
                data: { Id: id, EndTime: this.Model.endTime }
            });
            (this.$refs.packForm as any).resetFields();
            this.$emit('save-success');
            this.$emit('input', false);
        }

        cancel() {
            (this.$refs.packForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {

            if (!value) {
                this.$emit('input', value);
            } else {

            }
        }
    }
